import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions, CourierText } from "../ui/courier-fields";

const CreateCenterForm = ({
  closeModal,
  loading,
  apiError,
  zones = [],
  centerTypes = [],
  collectionCenters = [],
  onZoneChange,
  createCourierCenter
}) => (
    <FormModalShell title="Add Center" apiError={apiError} onClose={closeModal} columns={3}>
    <Formik
      initialValues={{
        zone: "",
        centerType: "",
        collectionCenter: "",
        name: "",
        address: "",
        latitude: "",
        longitude: "",
        contactPerson: "",
        contactNumber: ""
      }}
      validationSchema={Yup.object().shape({
        zone: Yup.string().required("Required field"),
        centerType: Yup.string().required("Required field"),
        name: Yup.string().required("Required field"),
        latitude: Yup.string().required("Required field"),
        longitude: Yup.string().required("Required field")
      })}
      onSubmit={values => {
        createCourierCenter({
          name: values.name,
          address: values.address,
          latitude: values.latitude,
          longitude: values.longitude,
          contactPerson: values.contactPerson,
          contactNumber: values.contactNumber,
          zone: Number(values.zone),
          centerType: Number(values.centerType),
          collectionCenter: values.collectionCenter
            ? Number(values.collectionCenter)
            : null
        });
      }}
    >
      {formik => {
        const applyCollectionCenter = ccId => {
          const cc = collectionCenters.find(
            c => String(c.id) === String(ccId)
          );
          if (cc) {
            formik.setFieldValue("name", cc.name || formik.values.name);
            formik.setFieldValue("latitude", cc.latitude || "");
            formik.setFieldValue("longitude", cc.longitude || "");
          }
        };

        return (
          <Form>
            <FormSelectRow
              label="Zone"
              name="zone"
              value={formik.values.zone}
              onChange={e => {
                formik.setFieldValue("zone", e.target.value);
                formik.setFieldValue("collectionCenter", "");
                onZoneChange && onZoneChange(e.target.value);
              }}
              error={formik.touched.zone && formik.errors.zone}
              required
              options={zones.map(z => ({ value: z.id, label: z.name }))}
            />
            <FormSelectRow
              label="Center Type"
              name="centerType"
              value={formik.values.centerType}
              onChange={e =>
                formik.setFieldValue("centerType", e.target.value)
              }
              error={formik.touched.centerType && formik.errors.centerType}
              required
              options={centerTypes.map(t => ({
                value: t.id,
                label: `${t.name}${t.isSpecial ? " (special)" : ""}`
              }))}
            />
            <FormSelectRow
              label="Collection Center (optional)"
              name="collectionCenter"
              value={formik.values.collectionCenter}
              onChange={e => {
                formik.setFieldValue("collectionCenter", e.target.value);
                applyCollectionCenter(e.target.value);
              }}
              placeholder="Manual / none"
              options={collectionCenters.map(c => {
                const verticalName = c.region?.vertical?.name;
                return {
                  value: c.id,
                  label: verticalName ? `${c.name} — ${verticalName}` : c.name
                };
              })}
            />
            <CourierText label="Display Name" name="name" />
            <CourierText label="Contact Person" name="contactPerson" />
            <CourierText label="Contact Number" name="contactNumber" />
            <CourierText label="Address" name="address" span />
            <CourierText label="Latitude" name="latitude" />
            <CourierText label="Longitude" name="longitude" />
            <CourierActions
              loading={loading}
              submitLabel="Add Center"
              onCancel={closeModal}
            />
          </Form>
        );
      }}
    </Formik>
  </FormModalShell>
);

export default CreateCenterForm;
